module.exports = __webpack_public_path__ + "media/Success_sound.37334939.mp3";